import type { AdminProjectAccessProject } from '@frontend/types';

async function authJson<T>(path: string, token: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init?.headers || {}),
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error((data as { message?: string }).message || `Request failed: ${response.status}`);
  }
  return data as T;
}

export async function fetchAdminProjectAccess(
  ecosystemId: string,
  token: string,
): Promise<AdminProjectAccessProject[]> {
  const data = await authJson<{ projects?: AdminProjectAccessProject[] }>(
    `/api/admin/project-access?ecosystem=${encodeURIComponent(ecosystemId)}`,
    token,
  );
  return data.projects || [];
}

export async function updateAdminProjectServices(
  projectId: string,
  services: string[],
  token: string,
): Promise<AdminProjectAccessProject> {
  const data = await authJson<{ project: AdminProjectAccessProject }>(
    `/api/admin/projects/${encodeURIComponent(projectId)}`,
    token,
    {
      method: 'PATCH',
      body: JSON.stringify({ services }),
    },
  );
  return data.project;
}

export async function reconcileAdminProject(
  projectId: string,
  token: string,
): Promise<{ runState?: string; correlationId?: string }> {
  return authJson(`/api/admin/projects/${encodeURIComponent(projectId)}/reconcile`, token, {
    method: 'POST',
    body: JSON.stringify({ flags: { sync: true } }),
  });
}
